import React from 'react'

import cx from 'classnames'

import styles from './styles.module.css'

interface CardProps {
  className?: string
  children?: any
  forwardRef?: React.MutableRefObject<HTMLDivElement>
}

const Card = (props: CardProps) => {
  const { className, children } = props
  return (
    <div ref={props.forwardRef} className={cx(className, styles.Card)}>
      {children}
    </div>
  )
}

export default Card
